module.exports = __webpack_public_path__ + "media/logo-accedo-control.ee4f1dd8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/src/images/logo-accedo-control.svg
// module id = 362
// module chunks = 0